import { isAiInput, SourceType } from '@/modules/surgicalEvent';
import { themeColors } from '@ianesthesie-kit/config';

export const getSourceTypeThemeColor = (
  source?: SourceType
): keyof typeof themeColors => {
  if (source === SourceType.AI_SUGGESTION) {
    return 'indigo';
  }

  if (source === SourceType.AI_OVERRIDE) {
    return 'orange';
  }

  if (source === SourceType.EPIC) {
    return 'slate';
  }

  if (source === SourceType.PATIENTS_APP) {
    return 'green';
  }

  if (source === SourceType.OCR) {
    return 'emerald';
  }

  if (source === SourceType.AUTOMATION) {
    return 'purple';
  }

  return 'slate';
};

export const isDisplayable = (sourceType?: SourceType) =>
  !!sourceType &&
  (sourceType === SourceType.OCR ||
    sourceType === SourceType.EPIC ||
    sourceType === SourceType.AUTOMATION ||
    sourceType === SourceType.PATIENTS_APP ||
    isAiInput(sourceType));
